import { Component } from '@angular/core';
import { SharedDataService } from '../../../../shared/services/shared-data-service/shared-data-service';

@Component({
  selector: 'ps-ui-supplier-allocation-modal',
  templateUrl: './supplier-allocation-modal.component.html',
  styleUrls: ['./supplier-allocation-modal.component.css'],
})
export class SupplierAllocationModalComponent {
  public surveyCreationObject: any = {};
  constructor(private _sharedDataService: SharedDataService) {
    this._sharedDataService.currentSurveySource.subscribe((data) => {
      this.surveyCreationObject = data;
    });
  }
}
